'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doHandleAddBanner = doHandleAddBanner;
exports.watchBannerSagas = watchBannerSagas;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _Banners = require('./Banners.reducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doHandleAddBanner),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchBannerSagas);

function doHandleAddBanner(_ref) {
  var _ref$data = _ref.data,
      timeout = _ref$data.options.timeout,
      id = _ref$data.id;
  return _regenerator2.default.wrap(function doHandleAddBanner$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(timeout > 0)) {
            _context.next = 5;
            break;
          }

          _context.next = 3;
          return (0, _effects.call)(_reduxSaga.delay, timeout);

        case 3:
          _context.next = 5;
          return (0, _effects.put)((0, _Banners.removeBanner)(id));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchBannerSagas() {
  return _regenerator2.default.wrap(function watchBannerSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, _Banners.ADD_BANNER, doHandleAddBanner);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}